import { render, staticRenderFns } from "./MensagemView.vue?vue&type=template&id=43a0b80a&"
import script from "./MensagemView.vue?vue&type=script&lang=js&"
export * from "./MensagemView.vue?vue&type=script&lang=js&"
import style0 from "./MensagemView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports